import { render } from "./DropDownField.vue?vue&type=template&id=b71b56ac"
import script from "./DropDownField.vue?vue&type=script&lang=js"
export * from "./DropDownField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/BuyVignette/components/DropDownField.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b71b56ac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b71b56ac', __exports__)) {
    api.reload('b71b56ac', __exports__)
  }
  
  module.hot.accept("./DropDownField.vue?vue&type=template&id=b71b56ac", () => {
    api.rerender('b71b56ac', render)
  })

}


export default __exports__